import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../services/api";
import { useAuthContext } from '../../Context/authContext';
import Logo from "../../img/logoUtiNeo.png";
import "./index.css";
import Swal from 'sweetalert2';

const Index = () => {
    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");

    const { login, isAuthenticated, user } = useAuthContext();

    // Redireciona se já estiver logado
    useEffect(() => {
        if (isAuthenticated && user) {
            navigate("/admin/cadastrar-conteudo", { replace: true });
        }
    }, [isAuthenticated, user, navigate]);

    const TentaLogarToken = async () => {
        if (!email || !password) {
            Swal.fire({
                icon: 'warning',
                title: 'Atenção',
                text: 'Preencha todos os campos',
            });
            return;
        }

        const result = await login(email, password);
        if (!result.success) {
            Swal.fire({
                icon: 'warning',
                title: 'Atenção',
                text: result.message,
            });
        } else {
            navigate('/admin/cadastrar-conteudo');
        }
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        TentaLogarToken();
    };

    return (
        <div className="TelaLoginInicial" align="center">
            <div className="PainelLogin">
                <div className="login-container p-4 shadow">
                    <div id="painelLOGO">
                        <img style={{ width: '100%', borderRadius: '10px' }} src={Logo} alt="Logo UTI Neonatal" />
                    </div>
                    <form style={{ paddingTop: "30px" }} onSubmit={handleSubmit}>
                        <div className="form-group mb-3" align="left">
                            <input
                                autoFocus
                                type="text"
                                className="form-control form-control-lg"
                                id="email"
                                placeholder="Email"
                                style={{ textAlign: "left", fontSize: "1em" }}
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                            />
                        </div>
                        <div className="form-group mb-4" align="left">
                            <input
                                type="password"
                                className="form-control form-control-lg"
                                id="senha"
                                placeholder="Senha"
                                style={{ textAlign: "left", fontSize: "1em" }}
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                            />
                        </div>
                        <button
                            type="submit"
                            className="btn btn-primary btn-lg w-100"
                            disabled={!email || !password}
                        >
                            ENTRAR
                        </button>
                        <button
                            type="button"
                            className="btn btn-outline-secondary btn-sm w-100 mt-3"
                            onClick={() => navigate('/')}
                        >
                            Voltar
                        </button>
                        <label id="msm_senha" className="text-danger d-none">Usuário e senha não conferem!</label>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default Index;
